import {
  SELECT_SERVICEORDER,
  SERVICEORDERS_REQUEST,
  SERVICEORDERS_CONTRACTOR_REQUEST,
  SERVICEORDERS_REQUEST_STOP,
  SERVICEORDER_CREATE_REQUEST,
  SERVICEORDER_DELETE_REQUEST,
  SERVICEORDER_FIND_REQUEST,
  SERVICEORDER_UPDATE_REQUEST,
  SERVICEORDER_ATTACHMENT_REQUEST,
  SERVICEORDER_CANCEL,
  SERVICEORDER_BILL,
  SERVICEORDER_PENDING_REQUEST,
  RESET_SERVICE_ORDER,
  SERVICEORDER_ATTACHMENT_DELETE_REQUEST,
  TECSUBMIT_IMAGES
} from "../action.types";

export const getAll = (page = 1, pageSize = 25, status, filter) => {
  return {
    type: SERVICEORDERS_REQUEST,
    payload: {
      request: {
        method: "get",
        url: `orderServices?page=${page}&pageSize=${pageSize}&search=${filter}${
          status ? `&status=${status}` : ""
        }`
      }
    }
  };
};

export const getAllByContractor = (contractorId, startDate, endDate) => {
  return {
    type: SERVICEORDERS_CONTRACTOR_REQUEST,
    payload: {
      request: {
        method: "get",
        url: `invoiceOrderServices?hirerId=${contractorId}&startAt=${startDate}&endAt=${endDate}&pageSize=1000`
      }
    }
  };
};

export const create = (orderService, companyId) => {
  return {
    type: SERVICEORDER_CREATE_REQUEST,
    payload: {
      request: {
        method: "post",
        url: `orderServices`,
        headers: companyId
          ? {
              "X-Tranpo-Company": companyId
            }
          : {},
        data: orderService
      }
    }
  };
};

export const update = (serviceOrder, companyId) => {
  return {
    type: SERVICEORDER_UPDATE_REQUEST,
    payload: {
      request: {
        method: "put",
        url: `orderServices/${serviceOrder.id}`,
        headers: companyId
          ? {
              "X-Tranpo-Company": companyId
            }
          : {},
        data: serviceOrder
      }
    }
  };
};

export const cancel = (serviceOrder, companyId) => {
  return {
    type: SERVICEORDER_CANCEL,
    payload: {
      request: {
        method: "put",
        url: `orderServices/${serviceOrder.id}`,
        headers: companyId
          ? {
              "X-Tranpo-Company": companyId
            }
          : {},
        data: serviceOrder
      }
    }
  };
};

export const bill = id => {
  return {
    type: SERVICEORDER_BILL,
    payload: {
      request: {
        method: "put",
        url: `orderservices/bill/${id}`
      }
    }
  };
};

export const inactive = id => {
  return {
    type: SERVICEORDER_DELETE_REQUEST,
    payload: {
      request: {
        method: "delete",
        url: `serviceOrders/${id}`
      }
    }
  };
};

export const getById = id => {
  return {
    type: SERVICEORDER_FIND_REQUEST,
    payload: {
      request: {
        method: "get",
        url: `orderServices/${id}`
      }
    }
  };
};

export const select = serviceorder => {
  return {
    type: SELECT_SERVICEORDER,
    serviceorder
  };
};

export const pending = serviceorder => {
  return {
    type: SERVICEORDER_PENDING_REQUEST,
    payload: {
      request: {
        method: "post",
        url: `orderservices/pending`,
        data: serviceorder
      }
    }
  };
};

export const stopServiceOrders = () => {
  return {
    type: SERVICEORDERS_REQUEST_STOP
  };
};

export const resetServiceOrder = () => {
  return {
    type: RESET_SERVICE_ORDER
  };
};

export const createAsDraft = serviceorder => {
  return {
    type: SERVICEORDER_CREATE_REQUEST,
    payload: {
      request: {
        method: "post",
        url: `orderservices/draft`,
        data: serviceorder
      }
    }
  };
};

export const createAttachments = (attachment, orderServiceId) => {
  return {
    type: SERVICEORDER_ATTACHMENT_REQUEST,
    payload: {
      request: {
        method: "post",
        url: `orderServices/${orderServiceId}/attachments`,
        data: attachment
      }
    }
  };
};

export const deleteAttachments = (orderServiceId, attachments) => {
  return {
    type: SERVICEORDER_ATTACHMENT_DELETE_REQUEST,
    payload: {
      request: {
        method: "delete",
        url: `orderServices/${orderServiceId}/attachments/${attachments.id}`
      }
    }
  };
};

export const getImagesTecSubmit = orderServiceId => {
  return {
    type: TECSUBMIT_IMAGES,
    payload: {
      request: {
        method: "get",
        url: `orderServices/${orderServiceId}/attachments`
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/redux/serviceOrder/serviceOrder.action.js